var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercardLight = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 24"
}), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 24,
  fill: "#fff",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ED0006",
  fillRule: "evenodd",
  d: "M20.286 18.302a7.8 7.8 0 0 1-5.059 1.855c-4.307 0-7.798-3.477-7.798-7.766 0-4.29 3.491-7.766 7.798-7.766 1.93 0 3.697.698 5.059 1.855a7.8 7.8 0 0 1 5.058-1.855c4.307 0 7.799 3.477 7.799 7.766s-3.492 7.766-7.799 7.766a7.8 7.8 0 0 1-5.058-1.855",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9A000",
  fillRule: "evenodd",
  d: "M20.286 18.302a7.74 7.74 0 0 0 2.74-5.911 7.74 7.74 0 0 0-2.74-5.91 7.8 7.8 0 0 1 5.058-1.856c4.307 0 7.799 3.477 7.799 7.766s-3.492 7.766-7.799 7.766a7.8 7.8 0 0 1-5.058-1.855",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5E00",
  fillRule: "evenodd",
  d: "M20.286 18.302a7.74 7.74 0 0 1-2.74-5.911 7.74 7.74 0 0 1 2.74-5.91 7.74 7.74 0 0 1 2.74 5.91 7.74 7.74 0 0 1-2.74 5.91",
  clipRule: "evenodd"
})));
export default SvgMastercardLight;